export default "__VITE_ASSET__wvls4uUd__"